function FeaturedProjects() {    
    const watchMobileWidth = window.matchMedia("(max-width: 640px)")
    const watchTabletWidth = window.matchMedia("(max-width: 1280px)")
    const watchDesktopWidth = window.matchMedia("(min-width: 1281px)")
    const watchPrefersMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    const featuredProjects = document.querySelectorAll('.home-featured-projects__box')

    if (featuredProjects) {
        featuredProjects.forEach((item, index) => {
            const card = item.firstElementChild
            const bgImg = item.children[1]
            const itemImg = item.children[2]
            
            const projectHeight = item.clientHeight
            const projectWidth = item.clientWidth
        
            const cardHeight = card.clientHeight
        
            const bgImgWidth = 1125
    
            if (!watchMobileWidth.matches && !watchPrefersMotion.matches && watchDesktopWidth.matches) {
                gsap.to(card, {
                    duration: 2.5,
                    scrollTrigger: {
                        trigger: item,
                        start: "top 50%",
                        end: "bottom",
                        scrub: 0.8
                    },
                    /* y: `${projectHeight - cardHeight}` */
                    y: `${projectHeight - cardHeight}`
                })
            
                if (index % 2 == 0) {
                    gsap.to(bgImg, {
                        scrollTrigger: {
                            trigger: item,
                            start: "top center",
                            end: "bottom 50px",
                            scrub: 0.55
                        },
                        x: `-${projectWidth - bgImgWidth}`
                    })
                    gsap.to(itemImg, {
                        scrollTrigger: {
                            trigger: item,
                            start: "top center",
                            end: "bottom 20px",
                            scrub: 0.55
                        },
                        x: `${projectWidth - bgImgWidth}`,
                        scale: 1.1
                    })
            
                } else {
                    gsap.to(bgImg, {
                        scrollTrigger: {
                            trigger: item,
                            start: "top center",
                            end: "bottom 50px",
                            scrub: 0.55
                        },
                        x: `${projectWidth - bgImgWidth}`
                    })
                    gsap.to(itemImg, {
                        scrollTrigger: {
                            trigger: item,
                            start: "top center",
                            end: "bottom 20px",
                            scrub: 0.55
                        },
                        x: `-${projectWidth - bgImgWidth}`,
                        scale: 1.1
                    })
                }
            }
    
            if (!watchMobileWidth.matches && !watchPrefersMotion.matches && watchTabletWidth.matches) {
                gsap.to(card, {
                    scrollTrigger: {
                        trigger: item,
                        start: "top center",
                        end: "bottom 50px",
                        scrub: 0.75
                    },
                    y: `${projectHeight - cardHeight}`
                })
            
                gsap.to(itemImg, {
                    scrollTrigger: {
                        trigger: item,
                        start: "top center",
                        end: "bottom 20px",
                        scrub: 0.55
                    },
                    y: -200,
                    scale: 1.1
                })
            }
        })
    }
}

export default FeaturedProjects